import styled from 'styled-components';

const Button = styled.button.withConfig({
  displayName: "Reset__Button",
  componentId: "sc-ohlhxz-0"
})(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;outline:none;text-align:inherit;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:antialiased;-webkit-appearance:none;&::-moz-focus-inner{border:0;padding:0;}-webkit-text-size-adjust:100%;"]);

export { Button as default };
